import React from 'react';
import c from 'classnames';
import { useRevolvingIndex } from '../../../../hooks/useRevolvingIndex';
import AutoCompleteMenu from './AutoCompleteMenu';
import { getDescendentId } from './utils';
import s from './AutoCompleteLayout.scss';
const AutoCompleteLayout = ({ items, menuId, onSelect, children, className, onKeyDown })=>{
    const { nextIndex, previousIndex, index: selectedIndex, setIndex } = useRevolvingIndex(items.length - 1);
    const handleKeyDown = (e)=>{
        let wasHandled = false;
        switch(e.key){
            case 'ArrowUp':
                previousIndex();
                wasHandled = true;
                break;
            case 'ArrowDown':
                nextIndex();
                wasHandled = true;
                break;
            case 'Home':
                setIndex(0);
                wasHandled = true;
                break;
            case 'End':
                setIndex(items.length - 1);
                wasHandled = true;
                break;
            case 'Enter':
            case 'Tab':
                if (items.length === 0) {
                    return;
                }
                onSelect(items[selectedIndex]);
                wasHandled = true;
                break;
            default:
                onKeyDown && onKeyDown(e);
        }
        if (wasHandled) {
            // Prevent any unintended page scrolling
            e.stopPropagation();
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        id: menuId,
        className: c(s['root'], className),
        role: "combobox",
        "aria-activedescendant": items.length > 0 ? getDescendentId(menuId, selectedIndex) : undefined,
        tabIndex: 0,
        "aria-controls": menuId,
        "aria-expanded": items.length > 0,
        onKeyDown: handleKeyDown
    }, children, items.length > 0 && /*#__PURE__*/ React.createElement(AutoCompleteMenu, {
        menuId: menuId,
        items: items,
        selectedIndex: selectedIndex,
        onSelectItem: onSelect
    }));
};
AutoCompleteLayout.displayName = 'AutoCompleteLayout';
export default AutoCompleteLayout;
